// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x4BPDhZijcPcht38HeWC {
    position: relative;
}

.J1NwLT1nlDB8qYnCuvTZ {
    width: 300px;
    padding: 6px 12px;
    border-radius: 25px;
    border: 1px solid #a1a1a1;
    display: flex;
    flex-direction: row;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25)
}

.C2tsai3L7yY555oE_BAX {
    width: 300px;
    position: absolute;
    z-index: 2;
    padding: 6px 12px;
    margin-top: 2px;
    border-radius: 12px;
    background: white;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25)
}

.YuQiXBncqGxz5rHnM5dg {
    width: 100%;
}

.V_UuB1g_HkWeI1Q8epxi:hover {
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/admin/css/search-container.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".container {\n    position: relative;\n}\n\n.search_box {\n    width: 300px;\n    padding: 6px 12px;\n    border-radius: 25px;\n    border: 1px solid #a1a1a1;\n    display: flex;\n    flex-direction: row;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25)\n}\n\n.drop_down_list_container {\n    width: 300px;\n    position: absolute;\n    z-index: 2;\n    padding: 6px 12px;\n    margin-top: 2px;\n    border-radius: 12px;\n    background: white;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25)\n}\n\n.drop_down_option_card {\n    width: 100%;\n}\n\n.search_drop_down_icon:hover {\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `x4BPDhZijcPcht38HeWC`,
	"search_box": `J1NwLT1nlDB8qYnCuvTZ`,
	"drop_down_list_container": `C2tsai3L7yY555oE_BAX`,
	"drop_down_option_card": `YuQiXBncqGxz5rHnM5dg`,
	"search_drop_down_icon": `V_UuB1g_HkWeI1Q8epxi`
};
export default ___CSS_LOADER_EXPORT___;
